import React, { useState , useEffect} from 'react';
import styles from './PageTitle.module.css'

type PageTitleProps = {
    title:string
}

const PageTitle = ({title}:PageTitleProps) =>{
    return(
        <h1 className={styles.PageTitle}>{title}</h1>
    );
}

export default PageTitle;